<template>
  <div ref="chart" class="chart-container"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

// 按需注册 ECharts 组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  PieChart,
  BarChart,
  LineChart,
  CanvasRenderer
])

let chartObserver = null

export default {
  name: 'BaseEchart',
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler(next) {
        if (this.chart) {
          this.chart.setOption(next, true)
        }
      },
      deep: true
    }
  },
  mounted() {
    this.initChart()
    this.observeAndResize()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    if (chartObserver && this.$refs.chart) {
      chartObserver.unobserve(this.$refs.chart)
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return
      this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption(this.option, true)
    },
    observeAndResize() {
      if (!this.$refs.chart) return

      chartObserver = new ResizeObserver(() => {
        if (this.chart) {
          this.chart.resize()
        }
      })
      chartObserver.observe(this.$refs.chart)
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  min-height: 120px;
}
</style>
